import React, { useState } from "react";
import { Colors } from "../utils/style";
import { Alert, Button, Placeholder, Spinner } from "react-bootstrap";
import CardComponent from "./CardComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
  faHandsAslInterpreting,
} from "@fortawesome/free-solid-svg-icons";
import { useStore } from "../store";
import axios from "axios";
import CodeCardComponent from "./CodeCardComponent";
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";
import CreditModal from "./CreditModal";
import { axiosInstance } from "../App";

function InterpretContainer(props: PropTypes) {
  const { explanations, setExplanations } = useStore();
  const {selectedGoal, setSelectedGoal} = useStore();
  const { visualisation, setVisualisation } = useStore();
  const { visualisation_image, setVisualisationImage } = useStore();
  const { selectedFileName, setSelectedFileName } = useStore();

  const { instructions, setInstructions } = useStore();
  const { interpretations, setIinterpretations } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const { t } = useTranslation("InterpretContainer");

  function onClickHandle() {
    //setExplanations(null);
    setLoading(true);
    setUploadError(false);

    const requestBody = {
      base64_image: visualisation_image,
      goal: selectedGoal,
      filename: selectedFileName,
      textgen_config: {
        temperature: 0,
        n: 1,
        model: "gpt-4",
        max_tokens: null,
        provider: "openai",
      },
    };
    //Todo
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "interpret", requestBody, {
        headers: {
          "Content-Type": "application/json",
          "Referrer-Policy": "no-referrer",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        setIinterpretations(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);

        
        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  return (
    <>
    <div
      style={{
        backgroundColor: Colors.DARK_GRAY,
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <div>
        {t("InterpretPrompt")}
      </div>
      <Button
        style={{
          width: "7rem",
        }}
        variant="success"
        onClick={onClickHandle}
      >
        <FontAwesomeIcon icon={faHandsAslInterpreting} /> {t("InterpretButton")}
      </Button>
      {loading && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Spinner animation="grow" variant="success" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
        </div>
      )}
      {uploadError && (
                  <></>

      )}
      {interpretations && (
        <CardComponent
          title={t("InterpretationTitle")}
          description={interpretations.content}
        ></CardComponent>
      )}
    </div>



    </>
  );
}

type PropTypes = {};

export default InterpretContainer;
